import React from 'react';
import { render } from 'react-dom';
import { DecisionUploadApp } from './DecisionUploadApp';
import { CustomWindow } from '../decisionUpload.types';

declare let window: CustomWindow;

const target = document.querySelector(`[data-react=doctrine-react]`);
if (target) {
  render(
    <DecisionUploadApp
      jurisdictionsKeys={window.JURIDICTIONS_SANS_VILLE}
      plansAllowed={window.PLANS_ALLOWED_TO_SEND_DECISION}
      jurisdictions={window.JURIDICTIONS ? window.JURIDICTIONS : null}
    />,
    target,
  );
} else {
  console.log(`doctrine-react is not visible in the DOM`);
}
